export const formatStoMMSS = function(time) {
    let mm = time / 60 | 0;
    let ss = time % 60 | 0;

    if (mm < 10) {
        mm = '0' + mm;
    }
    if (ss < 10) {
        ss = '0' + ss;
    }
    return `${mm}:${ss}`;


};

export const formatStoHHMMSS = function(seconds) {
    // var seconds = 9999;
    // multiply by 1000 because Date() requires miliseconds
    var date = new Date(seconds * 1000);
    var hh = date.getUTCHours();
    var mm = date.getUTCMinutes();
    var ss = date.getSeconds();
    // If you were building a timestamp instead of a duration, you would uncomment the following line to get 12-hour (not 24) time
    // if (hh > 12) {hh = hh % 12;}
    // These lines ensure you have two-digits
    if (hh < 10) { hh = "0" + hh; }
    if (mm < 10) { mm = "0" + mm; }
    if (ss < 10) { ss = "0" + ss; }

    return `${hh}:${mm}:${ss}`;
};

export const getApproxPersentage = function(persentage) {
    let approxPersentage;
    if(persentage >= 10 && persentage < 11){
        approxPersentage = 10
    }else if(persentage >= 20 && persentage < 21){
        approxPersentage = 20
    }else if(persentage >= 30 && persentage < 31){
        approxPersentage = 30
    }else if(persentage >= 40 && persentage < 41){
        approxPersentage = 40
    }else if(persentage >= 50 && persentage < 51){
        approxPersentage = 50
    }else if(persentage >= 60 && persentage < 61){
        approxPersentage = 60
    }else if(persentage >= 70 && persentage < 71){
        approxPersentage = 70
    }else if(persentage >= 80 && persentage < 81){
        approxPersentage = 80
    }else if(persentage >= 90 && persentage < 91){
        approxPersentage = 90
    }

    return approxPersentage;
            
}


